import { combineLatest, type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function allTrue(observables$: Observable<boolean>[]): Observable<boolean> {
    return combineLatest(observables$).pipe(map(booleans => booleans.every(bool => bool)));
}
